<!-- Mega Menu Backdrop Overlay (below header, covers rest of screen) -->
<div
  class="fixed top-[70px] inset-x-0 bottom-0 z-[990] animate-fade-in"
  [style.background-color]="'var(--color-primary-overlay)'"
  (click)="onClose()"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'modules' | translate"
></div>

<!-- Menu Panel -->
<div
  #menuPanel
  class="fixed top-[70px] left-0 right-0 z-[1000] animate-slide-down"
  (click)="$event.stopPropagation()"
>
    <div class="max-w-[1400px] mx-auto bg-white rounded-b-2xl shadow-card border border-t-0 border-line overflow-hidden">
      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-line">
        <div>
          <h2 class="text-lg font-extrabold text-dark-text tracking-tight">
            {{ 'modules' | translate }}
          </h2>
          <p class="text-xs text-gray-text mt-0.5">
            Jump to any module & its screens
          </p>
        </div>
        <button
          (click)="onClose()"
          class="h-8 w-8 grid place-items-center rounded-full bg-soft-bg hover:bg-gray-200 transition-colors duration-200 cursor-pointer"
          [attr.aria-label]="'close' | translate"
        >
          <ic-close
            [height]="12"
            [width]="12"
            startColor="var(--color-primary-end-color)"
            endColor="var(--color-primary-start-color)"
          ></ic-close>
        </button>
      </div>

      <!-- Module Grid -->
      <div class="p-sm max-h-[calc(100dvh-180px)] overflow-y-auto">
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-sm">
          @for (mod of modules(); track mod.key) {
            <div
              class="relative rounded-2xl border p-sm shadow-card flex flex-col gap-xsl transition-all duration-200"
              [class.border-gray-300]="isCurrentModule(mod.key)"
              [class.bg-gray-50]="isCurrentModule(mod.key)"
              [class.border-gray-200]="!isCurrentModule(mod.key)"
              [class.hover:border-gray-300]="!isCurrentModule(mod.key)"
              [class.hover:bg-gray-50]="!isCurrentModule(mod.key)"
            >
              <!-- Module Header -->
              <button
                (click)="onModuleClick(mod)"
                class="w-full flex items-center gap-sm pr-9 text-left cursor-pointer"
                [attr.aria-label]="mod.name"
              >
                <span
                  class="grid place-items-center h-10 w-10 rounded-full text-white shadow-sm shrink-0"
                  [style.background]="mod.color"
                >
                  @if (mod.icon) {
                    <app-module-icon
                      [iconName]="mod.icon"
                      [width]="16"
                      [height]="16"
                      [white]="true"
                    ></app-module-icon>
                  }
                </span>
                <span class="min-w-0">
                  <span class="block font-extrabold text-sm text-dark-text tracking-tight leading-tight truncate">
                    {{ mod.translationKey | translate }}
                  </span>
                  @if (isCurrentModule(mod.key)) {
                    <span class="block text-[10px] font-bold text-gray-text uppercase tracking-wide mt-0.5">
                      {{ 'current' | translate }}
                    </span>
                  }
                </span>
              </button>

              <!-- Screen List -->
              <div class="space-y-xs">
                @for (screen of mod.screens; track screen.key) {
                  <button
                    (click)="onScreenClick(mod.key, screen.key, screen.route, screen.queryParams)"
                    class="w-full flex items-center justify-between px-sm py-xs rounded-xl text-sm font-semibold transition-all duration-150 text-left cursor-pointer"
                    [class.bg-white]="isCurrentScreen(mod.key, screen.key)"
                    [class.text-dark-text]="isCurrentScreen(mod.key, screen.key)"
                    [class.shadow-card]="isCurrentScreen(mod.key, screen.key)"
                    [class.text-gray-text]="!isCurrentScreen(mod.key, screen.key)"
                    [class.hover:bg-white]="!isCurrentScreen(mod.key, screen.key)"
                    [class.hover:text-dark-text]="!isCurrentScreen(mod.key, screen.key)"
                    [attr.aria-current]="isCurrentScreen(mod.key, screen.key) ? 'page' : null"
                  >
                    <span class="truncate">{{ screen.translationKey | translate }}</span>
                    <ic-chevron-down
                      class="shrink-0 -rotate-90"
                      [height]="10"
                      [width]="10"
                      startColor="var(--color-gray-300)"
                      endColor="var(--color-gray-300)"
                      [opacity]="0.4"
                    ></ic-chevron-down>
                  </button>
                }
              </div>

              <!-- Pin Button (top-right) -->
              <button
                (click)="onTogglePin($event, mod.key, mod.screens[0].key)"
                class="absolute top-sm right-sm h-7 w-7 grid place-items-center rounded-full transition-all duration-200 cursor-pointer"
                [class.bg-gradient-primary]="isPinned(mod.key, mod.screens[0].key)"
                [class.text-white]="isPinned(mod.key, mod.screens[0].key)"
                [class.shadow-sm]="isPinned(mod.key, mod.screens[0].key)"
                [class.text-gray-300]="!isPinned(mod.key, mod.screens[0].key)"
                [class.hover:bg-gray-100]="!isPinned(mod.key, mod.screens[0].key)"
                [class.hover:text-gray-600]="!isPinned(mod.key, mod.screens[0].key)"
                [attr.aria-pressed]="isPinned(mod.key, mod.screens[0].key)"
                [attr.aria-label]="(isPinned(mod.key, mod.screens[0].key) ? 'Unpin ' : 'Pin ') + mod.name"
              >
                <ic-pin
                  [height]="14"
                  [width]="9"
                  defaultColor="currentColor"
                ></ic-pin>
              </button>
            </div>
          }
        </div>
    </div>
  </div>
</div>
